import { ChangeDetectionStrategy, Component, computed, inject, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { E_CONSENT } from '@ld.consumer-portal/constants';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-unconsent-modal',
  imports: [BaseModalComponent, MatIconModule, MatProgressSpinnerModule, TranslocoDirective],
  templateUrl: './unconsent-modal.component.html',
  styleUrl: './unconsent-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnconsentModalComponent {
  private readonly translocoService = inject(TranslocoService);

  readonly warningText = input<string>('');

  readonly confirm = output<void>();

  readonly cancel = output<void>();

  protected readonly isLoading = signal(false);

  protected readonly showConfirmation = signal(false);

  protected readonly defaultWarning = computed(() => this.translocoService.translate(E_CONSENT.withdrawWarning));

  protected readonly confirmationText = computed(() => this.translocoService.translate(E_CONSENT.withdrawConfirmation));

  protected onWithdraw(): void {
    if (!this.showConfirmation()) {
      this.showConfirmation.set(true);
      return;
    }
    this.isLoading.set(true);
    this.confirm.emit();
  }

  protected onCancel(): void {
    this.cancel.emit();
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget && !this.isLoading()) {
      this.cancel.emit();
    }
  }

  setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }
}
